import BoundaryPopUpOverlay from "../overlays/BoundaryOverlay/BoundaryOverlay";
import { Interactions } from "../reactOL/interactions";
import { Layers } from "../reactOL/layers";
import { Overlays } from "../reactOL/overlays";
import { State } from "../reactOL/source";
import { Map } from "../reactOL/map";
import { useMap } from "../../context/map";
import BoundaryVectorTileLayer from "./layers/BoundaryVectorTileLayer";
import LabelLayer from "./layers/LabelLayer";
import OsmTileLayer from "./layers/OsmTileLayer";
import BoundaryClick from "./interactions/BoundaryClick";

interface MapProps {
  setLoadingState: (state: State) => void;
  year: number;
}

const BoundaryMap = ({ setLoadingState, year }: MapProps) => {
  const { map, mapRef } = useMap();

  return (
    <Map map={map} mapRef={mapRef}>
      <Interactions>
        <BoundaryClick />
      </Interactions>
      <Layers>
        <OsmTileLayer />
        <BoundaryVectorTileLayer
          year={year}
          setLoadingState={setLoadingState}
        />
        <LabelLayer />
      </Layers>
      <Overlays>
        <BoundaryPopUpOverlay year={year} />
      </Overlays>
    </Map>
  );
};

export default BoundaryMap;
